module.exports = __webpack_public_path__ + "img/3-3.58d04845.svg";